import CustomSelection from './custom-selection';

export default class Match extends CustomSelection {
}
